import { cn } from 'lib/helpers/utility';
import { BRAND_COLORS, DEFAULT_BRAND_SHADE } from 'lib/constants/brandPalette';

const ColorGrid = ({
  value,
  shade = DEFAULT_BRAND_SHADE,
  onChange,
  cellClassName,
  dataQaPrefix = 'brand-color'
}) => (
  <div className="grid w-full grid-cols-5 gap-y-2" role="radiogroup">
    {BRAND_COLORS.map((color) => {
      const isSelected = value === color.key;
      const hex = color.shades[shade] || color.shades[DEFAULT_BRAND_SHADE];
      return (
        <button
          key={color.key}
          type="button"
          role="radio"
          aria-checked={isSelected}
          aria-label={color.label}
          data-qa={`${dataQaPrefix}-${color.key}`}
          onClick={() => onChange(color.key)}
          className={cn(
            'flex w-full min-w-0 cursor-pointer flex-col items-center justify-start gap-1 rounded-lg bg-transparent p-0 outline-none focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-600',
            cellClassName
          )}>
          <span
            className={cn(
              'flex h-10 w-10 items-center justify-center rounded-full border-2 border-solid transition-[transform,border-color] duration-150 hover:scale-105',
              isSelected ? 'p-[3px]' : 'border-transparent'
            )}
            style={{ borderColor: isSelected ? hex : 'transparent' }}>
            <span
              className="block h-full w-full rounded-full transition-colors duration-150"
              style={{ backgroundColor: hex }}
            />
          </span>
          <span className="text-center text-sm leading-[22px] text-neutral-700">{color.label}</span>
        </button>
      );
    })}
  </div>
);

export default ColorGrid;
